import { render, staticRenderFns } from "./cModalDoctoServicio.vue?vue&type=template&id=651126e9"
import script from "./cModalDoctoServicio.vue?vue&type=script&lang=js"
export * from "./cModalDoctoServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports